import { PermissionsGate } from 'features/permissions'
import {
  PERMISSION_CANTILEVER_ASSET_OVERVIEW_ADMIN,
  PERMISSION_CANTILEVER_ASSET_OVERVIEW_EDITOR,
} from 'types'

export interface DefinedGateProps {
  children: React.ReactNode
  fallback?: React.ReactNode
}

export const AssetOverviewAdminGate = (props: DefinedGateProps) => {
  const { children, fallback } = props
  return (
    <PermissionsGate
      requires={[PERMISSION_CANTILEVER_ASSET_OVERVIEW_ADMIN]}
      fallback={fallback}>
      {children}
    </PermissionsGate>
  )
}

export const AssetOverviewEditorGate = (props: DefinedGateProps) => {
  const { children, fallback } = props
  return (
    <PermissionsGate
      requires={[
        PERMISSION_CANTILEVER_ASSET_OVERVIEW_ADMIN,
        PERMISSION_CANTILEVER_ASSET_OVERVIEW_EDITOR,
      ]}
      fallback={fallback}>
      {children}
    </PermissionsGate>
  )
}
